import { render, staticRenderFns } from "./SourceDetailOverlay.vue?vue&type=template&id=d417583c&"
import script from "./SourceDetailOverlay.vue?vue&type=script&lang=ts&"
export * from "./SourceDetailOverlay.vue?vue&type=script&lang=ts&"
import style0 from "./SourceDetailOverlay.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports